// @flow

import { normalizarString } from "../util";

export const nomeCorresponde = (query: string, nome: string): boolean =>
  normalizarString(nome).includes(normalizarString(query));
